(function () {
  var owner = window.WAMORY_CUSTOMER && window.WAMORY_CUSTOMER.id ? 'customer-' + window.WAMORY_CUSTOMER.id : 'guest';
  var FAVORITES_KEY = 'wamory-shopify-favorites-' + owner;
  var locale = window.WAMORY_LOCALE || document.documentElement.lang || 'en';
  var isArabic = locale === 'ar';
  var searchTimer;

  function text(ar, en) { return isArabic ? ar : en; }
  function localizedPath(value) {
    if (!value || /^(?:#|mailto:|tel:|javascript:|data:)/i.test(value)) return value;
    var url;
    try { url = new URL(value, window.location.origin); } catch (_) { return value; }
    if (url.origin !== window.location.origin) return value;
    var root = String(window.WAMORY_ROUTES && window.WAMORY_ROUTES.root_url || '/').replace(/\/+$/, '');
    if (root && root !== '/' && url.pathname !== root && url.pathname.indexOf(root + '/') !== 0) {
      url.pathname = root + (url.pathname.charAt(0) === '/' ? url.pathname : '/' + url.pathname);
    }
    var requestedLanguage = new URLSearchParams(window.location.search).get('lang');
    if ((requestedLanguage === 'ar' || requestedLanguage === 'en') && !url.searchParams.has('lang')) {
      url.searchParams.set('lang', requestedLanguage);
    }
    return url.pathname + url.search + url.hash;
  }
  function localizeInternalLinks(root) {
    var links = [];
    if (root && root.matches && root.matches('a[href]')) links.push(root);
    if (root && root.querySelectorAll) links = links.concat(Array.from(root.querySelectorAll('a[href]')));
    links.forEach(function (link) {
      var localized = localizedPath(link.getAttribute('href'));
      if (localized && localized !== link.getAttribute('href')) link.setAttribute('href', localized);
    });
  }
  window.WAMORY_LOCALIZE_PATH = localizedPath;
  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[char];
    });
  }
  function formatMoney(cents, currency) { return window.WAMORY_MONEY.format(Number(cents)||0,currency); }
  function readFavorites() {
    // Hearts are kept on this device; My Wamory (account-page-v2.js) moves them into the account on her next visit.
    try {
      var saved = JSON.parse(localStorage.getItem(FAVORITES_KEY) || '[]');
      return Array.isArray(saved) ? saved : [];
    } catch (_) { return []; }
  }
  function renderFavorites() {
    var favorites = readFavorites();
    document.querySelectorAll('.favorite-count').forEach(function (el) {
      el.textContent = favorites.length;
      el.hidden = favorites.length === 0;
    });
    document.querySelectorAll('[data-shopify-favorite]').forEach(function (button) {
      var saved = favorites.indexOf(button.dataset.shopifyFavorite) !== -1;
      button.classList.toggle('is-saved', saved);
      button.setAttribute('aria-pressed', String(saved));
    });
  }
  var favoriteToastTimer;
  function favoriteFeedback(button, adding) {
    if (!document.getElementById('wm-fav-fx')) {
      var style = document.createElement('style');
      style.id = 'wm-fav-fx';
      style.textContent = '[data-shopify-favorite].is-saved svg{fill:#e47c93;stroke:#d96a83;color:#d96a83}'
        + '.wm-fav-pop svg{animation:wm-fav-pop .5s cubic-bezier(.2,1.6,.4,1)}'
        + '@keyframes wm-fav-pop{0%{transform:scale(1)}30%{transform:scale(.6)}65%{transform:scale(1.35)}100%{transform:scale(1)}}'
        + '.wm-fav-burst{position:fixed;z-index:2147483001;width:0;height:0;pointer-events:none}'
        + '.wm-fav-burst i{position:absolute;left:-6px;top:-8px;font:normal 12px/1 sans-serif;color:#e47c93;opacity:0;animation:wm-fav-fly .75s ease-out forwards}'
        + '@keyframes wm-fav-fly{0%{opacity:1;transform:translate(0,0) scale(.3)}70%{opacity:1}100%{opacity:0;transform:translate(var(--x),var(--y)) scale(1.05)}}'
        + '.wm-fav-toast{position:fixed;left:50%;top:calc(18px + env(safe-area-inset-top));z-index:2147483000;display:flex;align-items:center;gap:8px;max-width:calc(100vw - 32px);padding:11px 18px;border-radius:999px;background:#4a2f2a;color:#fff;font-weight:700;font-size:14px;line-height:1.35;box-shadow:0 10px 30px rgba(74,47,42,.28);opacity:0;transform:translate(-50%,-14px);transition:opacity .25s,transform .25s;pointer-events:none}'
        + '.wm-fav-toast.is-on{opacity:1;transform:translate(-50%,0)}'
        + '.wm-fav-toast svg{width:18px;height:18px;flex:none;fill:#f3a3b5}'
        + '@media (prefers-reduced-motion:reduce){.wm-fav-pop svg{animation:none}.wm-fav-burst{display:none}.wm-fav-toast{transition:none}}';
      document.head.appendChild(style);
    }
    button.classList.remove('wm-fav-pop');
    void button.offsetWidth;
    if (adding) {
      button.classList.add('wm-fav-pop');
      var heart = button.querySelector('svg') || button;
      var box = heart.getBoundingClientRect();
      var burst = document.createElement('span');
      burst.className = 'wm-fav-burst';
      burst.style.left = (box.left + box.width / 2) + 'px';
      burst.style.top = (box.top + box.height / 2) + 'px';
      for (var i = 0; i < 7; i++) {
        var angle = (i / 7) * Math.PI * 2 - Math.PI / 2;
        var piece = document.createElement('i');
        piece.textContent = '❤';
        piece.style.setProperty('--x', Math.round(Math.cos(angle) * 30) + 'px');
        piece.style.setProperty('--y', Math.round(Math.sin(angle) * 30) + 'px');
        piece.style.animationDelay = (i % 2) * 40 + 'ms';
        burst.appendChild(piece);
      }
      document.body.appendChild(burst);
      setTimeout(function () { burst.remove(); }, 900);
    }
    var toast = document.querySelector('.wm-fav-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'wm-fav-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7.5-4.6-9.6-9.2C.9 8.4 3 4.5 6.8 4.5c2.1 0 3.6 1.2 4.4 2.5.8-1.3 2.3-2.5 4.4-2.5 3.8 0 5.9 3.9 4.4 7.3C19.5 16.4 12 21 12 21z"/></svg><span></span>';
    toast.querySelector('span').textContent = adding ? text('تم الحفظ في مفضلاتكِ', 'Saved to your favourites') : text('أُزيلت من مفضلاتكِ', 'Removed from your favourites');
    toast.dir = isArabic ? 'rtl' : 'ltr';
    requestAnimationFrame(function () { toast.classList.add('is-on'); });
    clearTimeout(favoriteToastTimer);
    favoriteToastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 2200);
  }
  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  var searchDialog = document.getElementById('WamorySearchDialog');
  var searchInput = searchDialog && searchDialog.querySelector('[data-wamory-search-input]');
  var searchResults = searchDialog && searchDialog.querySelector('[data-wamory-search-results]');
  var searchStatus = searchDialog && searchDialog.querySelector('[data-wamory-search-status]');
  function openSearch() {
    if (!searchDialog || typeof searchDialog.showModal !== 'function') return false;
    searchDialog.showModal();
    document.body.classList.add('wamory-overlay-open');
    window.setTimeout(function () { if (searchInput) searchInput.focus(); }, 0);
    return true;
  }
  function closeSearch() {
    if (searchDialog && searchDialog.open) searchDialog.close();
    document.body.classList.remove('wamory-overlay-open');
  }
  function renderSearchProducts(products) {
    if (!searchResults) return;
    if (!products.length) {
      searchResults.innerHTML = '<p class="wamory-search-empty">' + text('لا توجد نتائج مطابقة.', 'No matching products.') + '</p>';
      return;
    }
    searchResults.innerHTML = products.map(function (product) {
      var image = product.featured_image && (product.featured_image.url || product.featured_image) || product.image || '';
      var price = product.price || '';
      return '<a class="wamory-predictive-item" href="' + escapeHtml(product.url) + '">' +
        (image ? '<img src="' + escapeHtml(image) + '" alt="" loading="lazy">' : '<span></span>') +
        '<span><strong>' + escapeHtml(product.title) + '</strong>' + (price ? '<small>' + escapeHtml(price) + '</small>' : '') + '</span></a>';
    }).join('');
  }
  function predictiveSearch(query) {
    if (!query || query.trim().length < 2) {
      if (searchResults) searchResults.innerHTML = '';
      if (searchStatus) searchStatus.textContent = '';
      return;
    }
    if (searchStatus) searchStatus.textContent = text('جارٍ البحث...', 'Searching...');
    var params = '?q=' + encodeURIComponent(query.trim()) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
    var endpoint = String(window.WAMORY_ROUTES.predictive_search_url || '/search/suggest').replace(/\.json$/, '') + '.json';
    function request(path) {
      return fetch(path + params, { headers: { Accept: 'application/json' } });
    }
    request(endpoint)
      .then(function (response) {
        if (response.ok) return response;
        if (endpoint !== '/search/suggest.json') return request('/search/suggest.json');
        throw new Error('Search failed');
      })
      .then(function (response) { if (!response.ok) throw new Error('Search failed'); return response.json(); })
      .then(function (payload) {
        var products = payload.resources && payload.resources.results && payload.resources.results.products || [];
        renderSearchProducts(products);
        if (searchStatus) searchStatus.textContent = products.length ? text('نتائج مقترحة', 'Suggested results') : '';
      })
      .catch(function () {
        if (searchStatus) searchStatus.textContent = text('تعذر تحميل الاقتراحات. استخدمي زر البحث.', 'Suggestions unavailable. Use the search button.');
      });
  }

  var drawer = document.getElementById('WamoryCartDrawer');
  var drawerBody = drawer && drawer.querySelector('[data-wamory-cart-body]');
  var drawerFooter = drawer && drawer.querySelector('[data-wamory-cart-footer]');
  var drawerTotal = drawer && drawer.querySelector('[data-wamory-cart-total]');
  var shippingProgress = drawer && drawer.querySelector('[data-wamory-shipping-progress]');
  var shippingMessage = shippingProgress && shippingProgress.querySelector('[data-wamory-shipping-message]');
  var shippingTrack = shippingProgress && shippingProgress.querySelector('[data-wamory-shipping-track]');
  var shippingFill = shippingProgress && shippingProgress.querySelector('[data-wamory-shipping-fill]');
  function renderShippingProgress(cart) {
    if (!shippingProgress || !shippingMessage || !shippingTrack || !shippingFill) return;
    var s=window.WAMORY_MONEY.state(cart);
    shippingProgress.hidden=false;shippingTrack.hidden=s.target===null;
    shippingMessage.textContent=s.remaining===null?text('يظهر حد الشحن بعملتكِ عند الدفع.','Shipping threshold shown at checkout.'):s.remaining?text('باقي '+formatMoney(s.remaining,s.currency)+' للشحن القياسي المجاني',formatMoney(s.remaining,s.currency)+' away from free standard shipping'):text('وصلتِ إلى حد الشحن القياسي المجاني.','Free standard shipping target reached.');
    shippingFill.style.width=s.progress+'%';shippingTrack.setAttribute('aria-valuenow',String(Math.round(s.progress)));shippingTrack.setAttribute('aria-valuetext',shippingMessage.textContent);
  }
  // The product page translates option names and values per product; the cart API only knows the store's raw values,
  // so the labels the shopper picked are remembered per variant and language for the popup, the drawer and the bag page.
  function storedLabels() { try { return JSON.parse(localStorage.getItem('wm-variant-labels') || '{}'); } catch (e) { return {}; } }
  function labelFor(variantId) { return storedLabels()[(isArabic ? 'ar:' : 'en:') + variantId] || null; }
  function rememberLabels(form) {
    var input = form && form.querySelector('[name="id"]'), scope = form && (form.closest('.wm-landing') || form), parts = [];
    if (!input || !scope) return;
    scope.querySelectorAll('.wm-option').forEach(function (set) {
      var chip = set.querySelector('.wm-choice[aria-pressed="true"]'), legend = set.querySelector('legend');
      if (!chip || !legend) return;
      var name = Array.prototype.filter.call(legend.childNodes, function (node) { return node.nodeType === 3; }).map(function (node) { return node.textContent; }).join('').trim();
      parts.push({ name: name, value: chip.dataset.wmLabel || chip.dataset.wmValue || '' });
    });
    // The product name as the shopper sees it (the cart API returns the store's base title, English for newer products).
    var heading = form.closest('.wm-landing') ? form.closest('.wm-landing').querySelector('h1') : (form.closest('.product-card') ? form.closest('.product-card').querySelector('h3') : null);
    var productName = heading ? heading.textContent.replace(/\s+/g, ' ').trim() : '';
    if (!parts.length && !productName) return;
    var all = storedLabels(), keys = Object.keys(all), key = (isArabic ? 'ar:' : 'en:') + input.value;
    if (keys.length > 80) keys.slice(0, keys.length - 80).forEach(function (old) { delete all[old]; });
    var entry = all[key] || {};
    if (parts.length) { entry.title = parts.map(function (part) { return part.value; }).join(' / '); entry.options = parts.map(function (part) { return part.name ? part.name + ': ' + part.value : part.value; }).join(' · '); }
    if (productName) entry.name = productName;
    all[key] = entry;
    try { localStorage.setItem('wm-variant-labels', JSON.stringify(all)); } catch (e) {}
  }
  var addedDialog = document.getElementById('WamoryAddedDialog');
  var addedTrigger = null;
  function showAddedConfirmation(cart, trigger) {
    if (!addedDialog || !cart) return loadCart(true);
    closeCart();
    addedTrigger = trigger;
    var s=window.WAMORY_MONEY.state(cart),currency=s.currency,subtotal=s.subtotal;
    var amount=addedDialog.querySelector('[data-wm-added-reward]');
    amount.textContent=s.cap===null?text('يُحسب عند الدفع','Calculated at checkout'):formatMoney(Math.min(s.cap,Math.round(subtotal*.07)),currency);
    var terms=addedDialog.querySelector('[data-wm-added-cap]');if(terms)terms.textContent=s.cap===null?'':formatMoney(s.cap,currency);
    var message=addedDialog.querySelector('[data-wm-added-shipping]'),track=addedDialog.querySelector('.wm-added-track');
    track.hidden=s.target===null;
    message.textContent=s.remaining===null?text('يظهر حد الشحن بعملتكِ عند الدفع.','Shipping threshold shown at checkout.'):s.remaining?text('أضيفي منتجات بقيمة '+formatMoney(s.remaining,currency)+' لتحصلي على شحن قياسي مجاني', 'Add '+formatMoney(s.remaining,currency)+' for free standard shipping'):text('وصلتِ إلى حد الشحن القياسي المجاني!','Free standard shipping target reached!');
    track.querySelector('span').style.width=s.progress+'%';track.setAttribute('aria-valuenow',String(Math.round(s.progress)));
    // A small confetti moment the first time in a visit that the bag reaches free standard shipping.
    if(s.target!==null&&s.remaining===0&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){var partyKey='wm-free-ship-party';var seen=false;try{seen=sessionStorage.getItem(partyKey)==='1';sessionStorage.setItem(partyKey,'1');}catch(e){}
      if(!seen){var colors=['#e8a0ae','#c2546f','#ffd36b','#b89bff','#7fd4ff','#7dcfa0'];for(var c=0;c<28;c++){var bit=document.createElement('i');bit.className='w99-confetti';bit.style.cssText='left:'+(Math.random()*100)+'vw;background:'+colors[c%colors.length]+';--x:'+((Math.random()-.5)*160)+'px;--r:'+(360+Math.random()*540)+'deg;--d:'+(1.3+Math.random()*1.1)+'s;animation-delay:'+(Math.random()*.25)+'s';addedDialog.appendChild(bit);setTimeout(function(n){return function(){n.remove();};}(bit),2900);}}}
    addedDialog.querySelector('[data-wm-added-subtotal]').textContent=formatMoney(subtotal,currency);
    addedDialog.querySelector('[data-wm-added-target]').textContent=s.target===null?'':formatMoney(s.target,currency);
    var variantInput=trigger?.closest('form')?.querySelector('[name="id"]'),item=(addedDialog.dataset.key&&!trigger&&cart.items.find(i=>i.key===addedDialog.dataset.key))||cart.items.find(i=>String(i.variant_id)===variantInput?.value)||cart.items[0];
    if(item){
      addedDialog.dataset.key=item.key;
      var picked=labelFor(item.variant_id),name=(picked&&picked.name)||item.product_title;
      var photo=addedDialog.querySelector('[data-wm-added-image]');photo.src=item.image||'';photo.hidden=!item.image;photo.alt=name;
      addedDialog.querySelector('[data-wm-added-name]').textContent=name;
      addedDialog.querySelector('[data-wm-added-options]').textContent=picked&&picked.options?picked.options:(item.options_with_values||[]).filter(o=>o.value!=='Default Title').map(o=>o.name+': '+o.value).join(' · ');
      addedDialog.querySelector('[data-wm-added-price]').textContent=formatMoney(item.final_line_price,currency);
      // Quantity stepper: change the amount right here (the bag updates, and so do the totals above).
      var qty=addedDialog.querySelector('[data-wm-added-quantity]');
      qty.className='wm-added-qty';qty.setAttribute('role','group');qty.setAttribute('aria-label',text('الكمية','Quantity'));
      qty.innerHTML='<button type="button" data-wm-added-step="-1" aria-label="'+text('تقليل الكمية','Decrease quantity')+'">'+(item.quantity>1?'−':'🗑')+'</button><output aria-live="polite">'+item.quantity+'</output><button type="button" data-wm-added-step="1" aria-label="'+text('زيادة الكمية','Increase quantity')+'">+</button>';
      qty.dataset.quantity=String(item.quantity);
    }
    if (!addedDialog.open) addedDialog.showModal();
  }
  function stepAddedQuantity(step) {
    var qty=addedDialog&&addedDialog.querySelector('[data-wm-added-quantity]'),key=addedDialog&&addedDialog.dataset.key;
    if(!qty||!key||qty.getAttribute('aria-busy')==='true')return;
    var next=Math.max(0,(Number(qty.dataset.quantity)||1)+step);
    qty.setAttribute('aria-busy','true');
    fetch(window.WAMORY_ROUTES.cart_change_url+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:next})})
      .then(function(response){if(!response.ok)throw new Error('Cart update failed');return response.json();})
      .then(function(cart){updateCartCount(cart.item_count);if(next===0||!cart.items.some(function(i){return i.key===key;})){addedDialog.close();return;}showAddedConfirmation(cart,null);})
      .catch(function(){window.location.href=window.WAMORY_ROUTES.cart_url;})
      .finally(function(){qty.removeAttribute('aria-busy');});
  }
  if (addedDialog) {
    addedDialog.querySelectorAll('[data-wm-added-close]').forEach(function(button) { button.addEventListener('click', function() { addedDialog.close(); }); });
    addedDialog.addEventListener('click', function(event) { if (event.target === addedDialog) { addedDialog.close(); return; } var step = event.target.closest('[data-wm-added-step]'); if (step) stepAddedQuantity(Number(step.dataset.wmAddedStep)); });
    addedDialog.addEventListener('close', function() { if (addedTrigger && document.contains(addedTrigger)) addedTrigger.focus(); });
  }
  function closeCart() {
    if (!drawer) return;
    drawer.hidden = true;
    document.body.classList.remove('wamory-overlay-open');
  }
  function renderCart(cart) {
    updateCartCount(cart.item_count);
    if (!drawerBody || !drawerFooter) return;
    if (!cart.items.length) {
      drawerBody.innerHTML = '<div class="wamory-cart-empty"><p>' + text('تنتظر حقيبتكِ أول اختيار.', 'Your first little find is waiting.') + '</p></div>';
      drawerFooter.hidden = true;
      return;
    }
    drawerBody.innerHTML = cart.items.map(function (item, index) {
      var picked = labelFor(item.variant_id);
      var options = item.variant_title && item.variant_title !== 'Default Title' ? '<small>' + escapeHtml(picked && picked.title ? picked.title : item.variant_title) + '</small>' : '';
      return '<div class="wamory-cart-line">' +
        (item.image ? '<a href="' + escapeHtml(item.url) + '"><img src="' + escapeHtml(item.image) + '" alt="" loading="lazy"></a>' : '<span></span>') +
        '<div class="wamory-cart-line-copy"><a href="' + escapeHtml(item.url) + '">' + escapeHtml((picked && picked.name) || item.product_title) + '</a>' + options + '<small>' + formatMoney(item.final_line_price, cart.currency) + '</small>' +
        '<div class="wamory-cart-quantity"><button type="button" data-cart-line="' + (index + 1) + '" data-cart-quantity="' + Math.max(0, item.quantity - 1) + '" aria-label="' + text('تقليل الكمية', 'Decrease quantity') + '">-</button><span>' + item.quantity + '</span><button type="button" data-cart-line="' + (index + 1) + '" data-cart-quantity="' + (item.quantity + 1) + '" aria-label="' + text('زيادة الكمية', 'Increase quantity') + '">+</button></div></div>' +
        '<button class="wamory-cart-remove" type="button" data-cart-line="' + (index + 1) + '" data-cart-quantity="0" aria-label="' + text('إزالة المنتج', 'Remove item') + '">x</button></div>';
    }).join('');
    drawerTotal.textContent = formatMoney(cart.total_price, cart.currency);
    renderShippingProgress(cart);
    drawerFooter.hidden = false;
  }
  function loadCart(open) {
    if (!drawer || !window.WAMORY_ROUTES) return Promise.resolve(null);
    if (open) {
      drawer.hidden = false;
      document.body.classList.add('wamory-overlay-open');
      drawerBody.innerHTML = '<div class="wamory-cart-loading">' + text('جارٍ تحميل الحقيبة...', 'Loading your bag...') + '</div>';
    }
    return fetch(window.WAMORY_ROUTES.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('Cart failed'); return response.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () { if (open) window.location.href = window.WAMORY_ROUTES.cart_url; return null; });
  }
  function changeCart(line, quantity) {
    if (!drawerBody) return;
    drawerBody.setAttribute('aria-busy', 'true');
    fetch(window.WAMORY_ROUTES.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    }).then(function (response) { if (!response.ok) throw new Error('Cart update failed'); return response.json(); })
      .then(renderCart)
      .catch(function () { window.location.href = window.WAMORY_ROUTES.cart_url; })
      .finally(function () { drawerBody.removeAttribute('aria-busy'); });
  }

  function closeMobileMenu() {
    var nav = document.getElementById('mobile-nav');
    if (!nav) return;
    nav.hidden = true;
    document.querySelectorAll('[data-action="menu"][aria-controls="mobile-nav"]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-label', text('افتحي القائمة', 'Open menu'));
    });
  }
  function toggleMobileMenu(button) {
    var nav = document.getElementById('mobile-nav');
    if (!nav) return;
    var opening = nav.hidden;
    nav.hidden = !opening;
    button.setAttribute('aria-expanded', String(opening));
    button.setAttribute('aria-label', opening ? text('أغلقي القائمة', 'Close menu') : text('افتحي القائمة', 'Open menu'));
  }
  function collectionPath(need) {
    var stageMatch = location.pathname.match(/\/pages\/(mother|newborn|discovery|adventure|toddler)\/?$/);
    var stage = stageMatch && stageMatch[1];
    if (stage) {
      var handle = stage === 'mother' || need === 'mom' ? 'mother-pregnancy' : 'wamory-stage-' + stage;
      return localizedPath('/collections/' + handle) + (need && need !== 'all' && need !== 'featured' && need !== 'mom' ? '?need=' + encodeURIComponent(need) : '') + '#wamory-picks';
    }
    var needHandles = {
      mom: 'mother-pregnancy',
      mother: 'mother-pregnancy',
      feeding: 'wamory-need-feeding',
      care: 'wamory-need-care',
      sleep: 'wamory-need-sleep',
      travel: 'wamory-need-travel',
      clothing: 'wamory-need-clothing',
      play: 'wamory-need-play',
      mealtime: 'wamory-need-mealtime',
      safety: 'wamory-need-safety'
    };
    if (needHandles[need]) return localizedPath('/collections/' + needHandles[need]);
    var path = window.WAMORY_ROUTES && window.WAMORY_ROUTES.all_products_collection_url || '/collections/all';
    return localizedPath(path);
  }

  function changeLanguage(target) {
    var form = document.getElementById('WamoryLocalizationForm');
    var select = form && form.querySelector('[name="language_code"], [name="locale_code"]');
    if (!form || !select || !Array.from(select.options).some(function (option) { return option.value === target; })) return false;
    var destination = new URL(window.location.href);
    destination.pathname = destination.pathname.replace(/^\/(?:ar|en)(?=\/|$)/, '') || '/';
    destination.searchParams.set('lang', target);
    var returnTo = form.querySelector('[name="return_to"]');
    if (returnTo) returnTo.value = destination.pathname + destination.search + destination.hash;
    select.value = target;
    form.submit();
    return true;
  }
  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-action="language"], .language-switch')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    changeLanguage(locale === 'ar' ? 'en' : 'ar');
  }, true);
  var nativeLocale = window.Shopify && window.Shopify.locale;
  if (['ar', 'en'].includes(nativeLocale) && nativeLocale !== locale) changeLanguage(locale);
  document.addEventListener('click', function (event) {
    var language = event.target.closest('[data-action="language"], .language-switch');
    if (language) {
      var form = document.getElementById('WamoryLocalizationForm');
      var select = form && form.querySelector('[name="language_code"], [name="locale_code"]');
      if (form && select && select.options.length > 1) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var alternate = Array.from(select.options).find(function (option) { return option.value !== (window.WAMORY_LOCALE || select.value); });
        if (alternate) { select.value = alternate.value; form.submit(); }
      }
      return;
    }
    var menuButton = event.target.closest('[data-action="menu"]');
    if (menuButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      toggleMobileMenu(menuButton);
      return;
    }
    var directAction = event.target.closest('[data-action="account"], [data-action="about"], [data-action="help"]');
    if (directAction) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var action = directAction.dataset.action;
      var destinations = {
        account: String(window.WAMORY_ROUTES.my_wamory_url || '/pages/my-wamory').split('#')[0],
        about: '/pages/about',
        help: '/pages/faq'
      };
      window.location.href = localizedPath(destinations[action]);
      return;
    }
    var stageTrigger = event.target.closest('[data-stage], [data-shop-stage]');
    if (stageTrigger) {
      var stage = stageTrigger.dataset.stage || stageTrigger.dataset.shopStage;
      var stagePaths = { pregnancy: '/pages/mother', mother: '/pages/mother', newborn: '/pages/newborn', discovery: '/pages/discovery', adventure: '/pages/adventure', toddler: '/pages/toddler', 'first-steps': '/pages/toddler', 'little-world': '/pages/toddler' };
      if (stagePaths[stage]) {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.href = localizedPath(stagePaths[stage]);
        return;
      }
    }
    var needTrigger = event.target.closest('[data-need], [data-nb-need], [data-jp-need], [data-discovery-need], [data-adventure-need]');
    if (needTrigger) {
      var need = needTrigger.dataset.need || needTrigger.dataset.nbNeed || needTrigger.dataset.jpNeed || needTrigger.dataset.discoveryNeed || needTrigger.dataset.adventureNeed;
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.href = collectionPath(need);
      return;
    }
    if (event.target.closest('#mobile-nav a')) closeMobileMenu();
    var searchLink = event.target.closest('[data-action="search"], a.icon-button[href*="/search"], .mobile-nav a[href*="/search"]');
    if (searchLink && !event.metaKey && !event.ctrlKey && !event.shiftKey && openSearch()) { event.preventDefault(); return; }
    if (event.target.closest('[data-wamory-search-close]')) { closeSearch(); return; }
    if (event.target === searchDialog) { closeSearch(); return; }
    var cartTrigger = event.target.closest('[data-action="cart"], .bag-button');
    if (cartTrigger && window.WAMORY_ROUTES) { event.preventDefault(); event.stopImmediatePropagation(); loadCart(true); return; }
    if (event.target.closest('[data-wamory-cart-close]')) { closeCart(); return; }
    var cartChange = event.target.closest('[data-cart-line][data-cart-quantity]');
    if (cartChange) { changeCart(cartChange.dataset.cartLine, cartChange.dataset.cartQuantity); return; }
    var quantityStep = event.target.closest('[data-quantity-step]');
    if (quantityStep) {
      var quantityInput = quantityStep.closest('.product-quantity-control').querySelector('input[name="quantity"]');
      if (quantityInput) {
        var minimum = Number(quantityInput.min) || 1;
        var nextQuantity = Math.max(minimum, (Number(quantityInput.value) || minimum) + Number(quantityStep.dataset.quantityStep));
        quantityInput.value = String(nextQuantity);
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }
    var prototypeAdd = event.target.closest('[data-add], [data-shop-add-bundle]');
    if (prototypeAdd && !prototypeAdd.closest('form')) { event.preventDefault(); event.stopImmediatePropagation(); window.location.href = collectionPath(); return; }
    var favorite = event.target.closest('[data-shopify-favorite]');
    if (favorite) {
      // Saved in place: a little heart animation and a short notice, no trip to My Wamory.
      event.preventDefault();
      var favorites = readFavorites();
      var handle = favorite.dataset.shopifyFavorite;
      var index = favorites.indexOf(handle);
      var adding = index === -1;
      if (adding) favorites.push(handle); else favorites.splice(index, 1);
      try { localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites)); } catch (_) {}
      // The product page's own pink-heart memory (data-wm-save-feedback) follows the same choice.
      try {
        var heartKey = 'wamory-save-heart-' + (window.WAMORY_CUSTOMER && window.WAMORY_CUSTOMER.id || 'guest') + '-' + handle;
        if (adding) sessionStorage.setItem(heartKey, 'selected'); else sessionStorage.removeItem(heartKey);
      } catch (_) {}
      renderFavorites();
      favoriteFeedback(favorite, adding);
      document.dispatchEvent(new CustomEvent('wamory:favorite', { detail: { button: favorite, handle: handle, adding: adding } }));
      return;
    }
    var favoritesAction = event.target.closest('[data-action="favorites"], .favorites-action');
    if (favoritesAction && window.WAMORY_ROUTES && window.WAMORY_ROUTES.my_wamory_url) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (window.WAMORY_SYNCED_ACCOUNT_URL) {
        var listUrl = new URL(window.WAMORY_SYNCED_ACCOUNT_URL, location.origin);
        listUrl.searchParams.set('view', 'saved');
        listUrl.searchParams.set('locale', isArabic ? 'ar' : 'en');
        window.location.href = listUrl.toString();
        return;
      }
      window.location.href = `${String(window.WAMORY_ROUTES.my_wamory_url).split('#')[0]}#favorites`;
    }
  }, true);

  if (searchInput) searchInput.addEventListener('input', function () {
    window.clearTimeout(searchTimer);
    searchTimer = window.setTimeout(function () { predictiveSearch(searchInput.value); }, 180);
  });
  if (searchDialog) searchDialog.addEventListener('close', function () { document.body.classList.remove('wamory-overlay-open'); });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeMobileMenu();
    closeSearch();
    closeCart();
  });
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.wamory-card-form, .wamory-product-form, .wm-buy-form');
    if (!form || !window.fetch || !window.WAMORY_ROUTES) return;
    event.preventDefault();
    if (form.dataset.wamoryAdding === 'true') return;
    var submit = form.querySelector('[type="submit"]');
    var wasDisabled = submit && submit.disabled;
    if (wasDisabled) return;
    var data = new FormData(form);
    var error = form.querySelector('.wm-cart-error');
    if (!error) { error = document.createElement('p'); error.className = 'wm-cart-error'; error.setAttribute('role', 'alert'); error.style.cssText='font-size:12px;color:#a95665;margin:8px 0'; form.append(error); }
    error.textContent = '';
    form.dataset.wamoryAdding = 'true';
    form.setAttribute('aria-busy', 'true');
    if (submit) submit.disabled = true;
    fetch(window.WAMORY_ROUTES.cart_add_url + '.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json().then(function(payload) { if (!response.ok) throw new Error(payload.description || payload.message || text('تعذرت الإضافة؛ حاولي مرة أخرى.', 'Unable to add; please try again.')); return payload; }); })
      .then(function () { rememberLabels(form); return loadCart(false).then(function(cart) { return showAddedConfirmation(cart, submit); }); })
      .catch(function (failure) { error.textContent = failure.message || text('تعذرت الإضافة؛ حاولي مرة أخرى.', 'Unable to add; please try again.'); })
      .finally(function() { form.dataset.wamoryAdding = 'false'; form.removeAttribute('aria-busy'); if (submit) { var nativeOption=form.querySelector('[name="id"] option:checked'); var variantData=form.closest('.wm-landing'); variantData=variantData && variantData.querySelector('.wm-variant-data'); var selectedVariant=variantData && JSON.parse(variantData.textContent).find(function(v) { return String(v.id) === form.querySelector('[name="id"]').value; }); submit.disabled=wasDisabled || Boolean(nativeOption && nativeOption.disabled) || Boolean(selectedVariant && !selectedVariant.available); } });
  });
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-image]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (main) main.src = button.dataset.galleryImage;
        gallery.querySelectorAll('[data-gallery-image]').forEach(function (item) { item.classList.toggle('is-active', item === button); });
      });
    });
  });
  document.querySelectorAll('.wamory-product-form').forEach(function (form) {
    var payload = form.parentElement.querySelector('[data-product-variants]');
    var variants = payload ? JSON.parse(payload.textContent) : [];
    var selects = Array.from(form.querySelectorAll('[data-product-option]'));
    var gallery = form.closest('.product-summary').parentElement.querySelector('[data-product-gallery]');
    var price = form.parentElement.querySelector('[data-product-price]');
    var availability = form.parentElement.querySelector('[data-product-availability]');
    function selectVariant() {
      var options = selects.map(function (select) { return select.value; });
      var variant = variants.find(function (item) { return item.options.every(function (value, index) { return value === options[index]; }); });
      if (!variant) return;
      form.querySelector('[name="id"]').value = variant.id;
      var submit = form.querySelector('[type="submit"]');
      if (submit) submit.disabled = !variant.available;
      selects.forEach(function (select) {
        var group = form.querySelector('[data-visual-option][data-option-position="' + select.dataset.optionPosition + '"]');
        if (!group) return;
        group.querySelectorAll('[data-option-choice]').forEach(function (choice) {
          var selected = choice.dataset.optionValue === select.value;
          choice.classList.toggle('is-selected', selected);
          choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      });
      if (price) {
        var currentPrice = price.querySelector('strong');
        var comparePrice = price.querySelector('s');
        if (currentPrice) currentPrice.textContent = formatMoney(variant.price, variant.price_currency || window.Shopify && window.Shopify.currency && window.Shopify.currency.active);
        if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
          if (!comparePrice) { comparePrice = document.createElement('s'); price.appendChild(comparePrice); }
          comparePrice.textContent = formatMoney(variant.compare_at_price, variant.price_currency || window.Shopify && window.Shopify.currency && window.Shopify.currency.active);
          comparePrice.hidden = false;
        } else if (comparePrice) comparePrice.hidden = true;
      }
      if (availability) availability.textContent = variant.available ? text('متوفر', 'In stock') : text('غير متوفر', 'Sold out');
      if (gallery) {
        var selectedChoice = form.querySelector('[data-option-choice].is-selected[data-option-image]');
        var image = selectedChoice && selectedChoice.dataset.optionImage || variant.featured_image && variant.featured_image.src;
        if (image) {
          var main = gallery.querySelector('[data-gallery-main]');
          if (main) {
            main.src = image;
            main.removeAttribute('srcset');
          }
          gallery.querySelectorAll('[data-gallery-image]').forEach(function (button) {
            button.classList.toggle('is-active', button.dataset.galleryImage === image || button.dataset.galleryImage.indexOf(image.split('?')[0]) !== -1);
          });
        }
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      } catch (_) {}
    }
    selects.forEach(function (select) { select.addEventListener('change', selectVariant); });
    form.querySelectorAll('[data-option-choice]').forEach(function (choice) {
      choice.addEventListener('click', function () {
        var select = selects.find(function (item) { return item.dataset.optionPosition === choice.dataset.optionPosition; });
        if (!select) return;
        select.value = choice.dataset.optionValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    selectVariant();
  });
  localizeInternalLinks(document);
  if (document.body && window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) localizeInternalLinks(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.body && (document.body.dataset.page === 'guide' || document.body.dataset.page === 'article')) {
    var nativeProducts = document.querySelector('.wamory-native-products');
    var deferredNativeProducts = document.getElementById('WamoryDeferredNativeProducts');
    var pageRoot = document.querySelector('#guide-root, #article-root');
    var pageMain = pageRoot && pageRoot.closest('main');
    if (!nativeProducts && deferredNativeProducts && deferredNativeProducts.content.firstElementChild) {
      nativeProducts = deferredNativeProducts.content.firstElementChild.cloneNode(true);
    }
    if (nativeProducts && pageMain && !pageMain.contains(nativeProducts)) pageMain.appendChild(nativeProducts);
    if (deferredNativeProducts) deferredNativeProducts.remove();
    if (nativeProducts) localizeInternalLinks(nativeProducts);
  }
  renderFavorites();
  loadCart(false);
})();
